//#region INTERFACE IOpenOrderViewSettings
export interface IOpenOrderViewSettings {
  inclDaysNegative: boolean;
  inclDaysZero: boolean;
  mainSupplierItems: boolean;
  meetOrderLevel: boolean;
  otherSupplierItems: boolean;
  packSize: boolean;
  showLineColours: boolean;
  subtractPurchaseOrders: boolean;
}

//#endregion